import itemServices from 'services/store/item';
import itemAssetServices from 'services/store/itemAsset';

export default {
	...itemServices,
	...itemAssetServices,
};
